module.exports = __webpack_public_path__ + "static/gallery-13-e66316f7b826c9f61fe9e2b70e3c6d84.jpg";